<template>
  <label :class="labelClass" class="font-medium mb-1 text-white" :for="forId">
    {{ label }}
  </label>
</template>

<script>
export default {
  name: "Label",
  props: {
    label: String,
    labelClass: String,
    forId: String,
  },
};
</script>
